import api from './api';

export const matchService = {
    // Get user matches with pagination
    getUserMatches: async (userId, offset = 0, limit = 10) => {
        try {
            const response = await api.get(`/match/userid/${userId}`, {
                params: {
                    offset,
                    limit
                }
            });
            return {
                matches: response.data,
                hasMore: response.data.length === limit,
                nextOffset: offset + response.data.length
            };
        } catch (error) {
            console.error('Error fetching matches:', error);
            throw error;
        }
    },

    // Récupérer les détails d'un utilisateur
    getUserDetails: async (userId) => {
        try {
            const response = await api.get(`/user/fbid/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user details:', error);
            throw error;
        }
    },

    // Récupérer les conversations d'un utilisateur
    getUserConversations: async (userId) => {
        try {
            const response = await api.get(`/conversation/userid/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching conversations:', error);
            throw error;
        }
    },

    // Marquer une conversation comme lue
    markConversationAsRead: async (conversationId, userId) => {
        try {
            const response = await api.put(`/conversation/${conversationId}/read/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error marking conversation as read:', error);
            throw error;
        }
    }
};
